<fui-rows [formGroup]="editService.formGroup">
    <fui-row [label]="'wbo.pricing.schedule.field-set.first'">
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-date-edit-control [label]="'wbo.pricing.schedule.field.startDate.label'"
                                           formControlName="startDate"
                                           [(ngModel)]="model.data.startDate"></wbo-date-edit-control>
                    <wbo-time-edit-control [label]="'wbo.pricing.schedule.field.startTime.label'"
                                           formControlName="startTime"
                                           [(ngModel)]="model.data.startTime"
                                           (valueChange)="startTimeValueChange()"></wbo-time-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <fui-tandem-field>
                    <wbo-time-edit-control [label]="'wbo.pricing.schedule.field.firstFinishTime.label'"
                                           formControlName="firstFinishTime"
                                           [(ngModel)]="model.data.firstFinishTime"
                                           (valueChange)="firstFinishTimeValueChange()"></wbo-time-edit-control>
                    <wbo-text-edit-control [label]="'wbo.pricing.schedule.field.durationHHMM.label'"
                                           [placeholder]="'wbo.pricing.schedule.field.durationHHMM.placeholder'"
                                           [readonly]="true"
                                           formControlName="durationHHMM"
                                           [(ngModel)]="model.data.durationHHMM"></wbo-text-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row [label]="'wbo.pricing.schedule.field-set.recurring'"
             [switched]="true" [(enabled)]="model.data.recurring" (enabledChange)="recurringChange()">
        <fui-two-columns>
            <fui-column [label]="'wbo.pricing.schedule.field-set.occurs'">
                <fui-tandem-field>
                    <wbo-numeric-edit-control [label]="'wbo.pricing.schedule.field.frequencyValue.label'"
                                              [placeholder]="'wbo.pricing.schedule.field.frequencyValue.placeholder'"
                                              formControlName="frequencyValue"
                                              [decimals]="0"
                                              [(ngModel)]="model.data.frequencyValue"
                                              [overrideRequired]="model.data.recurring"></wbo-numeric-edit-control>
                    <wbo-single-select-edit-control [label]="'wbo.pricing.schedule.field.frequencyUnit.label'"
                                                    [placeholder]="'wbo.pricing.schedule.field.frequencyUnit.placeholder'"
                                                    formControlName="frequencyUnit"
                                                    [allowClearSelectionOption]="false"
                                                    [(ngModel)]="model.data.frequencyUnit"
                                                    (valueChange)="frequencyUnitValueChange()">
                        <wbo-select-options>
                            <wbo-select-option [value]="PricingScheduleFrequency.MINUTES"
                                               [label]="'wbo.pricing.schedule.option.frequencyUnit.minutes'">
                            </wbo-select-option>
                            <wbo-select-option [value]="PricingScheduleFrequency.HOURS"
                                               [label]="'wbo.pricing.schedule.option.frequencyUnit.hours'">
                            </wbo-select-option>
                            <wbo-select-option [value]="PricingScheduleFrequency.DAYS"
                                               [label]="'wbo.pricing.schedule.option.frequencyUnit.days'">
                            </wbo-select-option>
                            <wbo-select-option [value]="PricingScheduleFrequency.WEEKS"
                                               [label]="'wbo.pricing.schedule.option.frequencyUnit.weeks'">
                            </wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column [label]="'wbo.pricing.schedule.field-set.until'">
                <fui-tandem-field>
                    <wbo-date-edit-control [label]="'wbo.pricing.schedule.field.finishDate.label'"
                                           formControlName="finishDate"
                                           [(ngModel)]="model.data.finishDate"
                                           [overrideRequired]="model.data.recurring"></wbo-date-edit-control>
                    <wbo-time-edit-control [label]="'wbo.pricing.schedule.field.finishTime.label'"
                                           formControlName="finishTime"
                                           [(ngModel)]="model.data.finishTime"
                                           [overrideRequired]="model.data.recurring"></wbo-time-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
